import { render, staticRenderFns } from "./global-search-button.vue?vue&type=template&id=345c4d39"
import script from "./global-search-button.vue?vue&type=script&lang=js"
export * from "./global-search-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports